import {AccountService} from '../../services/AccountService';
import {ChartUtil} from '../../utils/chart/ChartUtil';

export const WIDGET_BALANCE_DAYS = 'widget.balanceDays';
export const BARCHART_WIDGET_KEY = 'barChartWgtKey';

/** @ngInject */
export class WidgetController{
    constructor($scope, userService, arsMainDependencies, title, icon, moduleParamsKey) {
        this.$scope = $scope;
        this.userService = userService;
        this.state = arsMainDependencies.$state;
        this.translate = userService.fsMainDependencies.$translate;
        this.sessionPersistance = userService.fsMainDependencies.sessionPersistance;
        this.title = title;
        this.icon = icon;
        this.store = arsMainDependencies.store;
        this.moduleParamsKey = moduleParamsKey;
        this.getModuleParams();
        this.accountService = new AccountService(userService);
        this.availableSizes = ['L', 'M', 'S'];
        this.menuItems = [];

        if(this.moduleParamsKey == BARCHART_WIDGET_KEY) {
            this.days = ChartUtil.getBalanceHistChartDays(this.translate);
            this.sessionPersistance.promise.then(()=> {
                this.$scope.selDay = this.sessionPersistance.get(WIDGET_BALANCE_DAYS) || this.days[0].value;
            });
        }

        if($scope.controller) {
            this.loadWidgetContent();
        }
    }

    loadWidgetContent() {
        // overwrites by kids
    }

    openSettings($mdMenu, ev) {
        this.originatorEv = ev;
        $mdMenu.open(ev);
    }

    getModuleParams() {
        this.sessionPersistance.promise.then(()=> {
            this.moduleParams =   this.sessionPersistance.get(this.moduleParamsKey) || {selected: false, position: null, size: 'L'};
            this.selected = this.moduleParams.selected;
            this.size = this.moduleParams.size;
        });
    }

    unSelect() {
        this.changeProperty(false, 'selected');
        this.selected = false;
    }

    changeSize(size) {
        this.changeProperty(size, 'size');

        this.size = size;
        this.state.reload();
    }

    changeProperty(value, property) {
        this.moduleParams = this.sessionPersistance.get(this.moduleParamsKey) || {selected: false, position: null, size: 'L'};
        if (this.moduleParams[property] !== value) {
            this.moduleParams[property] = value;
            this.sessionPersistance.set(this.moduleParamsKey, this.moduleParams);
        }
    }

    changeSubPanel(value, property) {
        this.subPanelType = value;
        this.changeProperty(value, property);
        this.$scope.$broadcast('subPanelType.change', value);
    }

    loadBalance(day) {
        this.sessionPersistance.set(WIDGET_BALANCE_DAYS, day);
        this.$scope.selDay = day;
        this.$scope.$broadcast('selDay.change', day);
    }
}
